import { motion } from "framer-motion";
import { Users, TrendingUp, BarChart3, Handshake } from "lucide-react";
import { CAPABILITIES } from "../../lib/portfolioData";
import { SectionHeader, Reveal } from "./Reveal";

const ICONS = {
  stakeholder: Users,
  commercial: TrendingUp,
  adsales: BarChart3,
  sponsorship: Handshake,
};

export const Capabilities = () => (
  <section id="capabilities" data-testid="capabilities-section" className="relative py-28 md:py-44">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <SectionHeader chapter="02" overline="Core Capabilities" title="Where I create commercial leverage." />

      <div className="grid md:grid-cols-12 gap-5 md:gap-6">
        {CAPABILITIES.map((cap, i) => {
          const Icon = ICONS[cap.id];
          return (
            <Reveal key={cap.id} delay={i * 0.08} className={cap.span}>
              <motion.div
                whileHover={{ y: -6 }}
                data-testid={`capability-${cap.id}`}
                className="group h-full rounded-3xl border border-white/10 bg-[#0a1220]/60 p-8 md:p-10 hover:border-accent/50 transition-colors duration-500 relative overflow-hidden"
              >
                <div className="absolute -top-24 -right-24 w-48 h-48 spotlight opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative flex items-start justify-between mb-8">
                  <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center text-accent group-hover:bg-accent group-hover:text-[#04110b] transition-colors duration-500">
                    <Icon size={22} />
                  </div>
                  <span className="font-display text-2xl text-white/10">0{i + 1}</span>
                </div>
                <h3 className="relative font-display text-2xl md:text-3xl tracking-tight mb-4">
                  {cap.title}
                </h3>
                <p className="relative text-[#94a3b8] leading-relaxed max-w-md">{cap.blurb}</p>
                {cap.tags && (
                  <div className="relative flex gap-2 mt-6">
                    {cap.tags.map((t) => (
                      <span key={t} className="text-xs font-medium px-3 py-1 rounded-full border border-accent/30 text-accent">
                        {t}
                      </span>
                    ))}
                  </div>
                )}
              </motion.div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
